<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <NavbarComponent v-if="!isLoginPage" />

    <div class="container-fluid flex-grow-1">
      <div class="row flex-nowrap">
        <SidebarComponent v-if="!isLoginPage"
                         :role="currentUser?.role?.name"
                         class="col-auto d-none d-md-block" />
        <main :class="[
          isLoginPage ? 'col-12' : 'col-12 col-md min-vh-100'
        ]">
          <div :class="{ 'px-md-4 py-3': !isLoginPage }">
            <RouterView />
          </div>
        </main>
      </div>
    </div>

    <FooterComponent v-if="!isLoginPage" />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import NavbarComponent from '@/components/layout/NavbarComponent.vue'
import SidebarComponent from '@/components/layout/SidebarComponent.vue'
import FooterComponent from '@/components/layout/FooterComponent.vue'

export default {
  name: 'App',
  components: {
    NavbarComponent,
    SidebarComponent,
    FooterComponent
  },
  setup() {
    const store = useStore()
    const route = useRoute()

    const currentUser = computed(() => store.state.auth.user)
    const isLoginPage = computed(() => route.name === 'login')

    onMounted(() => {
      // Try to restore authentication state on app startup
      const token = localStorage.getItem('access_token')
      const user = localStorage.getItem('user')

      if (token && user) {
        try {
          const userData = JSON.parse(user)
          store.dispatch('auth/loginSuccess', { access_token: token, user: userData })
        } catch (e) {
          // Clear invalid data
          localStorage.removeItem('access_token')
          localStorage.removeItem('user')
        }
      }
    })

    return {
      currentUser,
      isLoginPage
    }
  }
}
</script>

<style lang="scss">
@use '@/styles/custom.scss';
</style>